import React from 'react'
import {useAuth} from '../../../app/modules/auth'
import clsx from 'clsx'
import {KTSVG} from '../../helpers'
import './TrialBanner.css'

export const TRIAL_BANNER_HEIGHT = 40

export function useTrialBannerVisible() {
  const {currentUser} = useAuth()
  const instance = currentUser?.instance
  const plan = instance?.plan
  const trialStartedAt = instance?.trial_started_at

  if (plan?.name.toLowerCase() != 'plano trial' || !trialStartedAt) return {visible: false, height: 0}

  const trialStartedAtDate = new Date(trialStartedAt)
  const now = new Date()
  const diffTime = now.getTime() - trialStartedAtDate.getTime()
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24))
  const daysLeft = 15 - diffDays

  if (daysLeft <= 0) return {visible: false, height: 0}

  return {visible: true, height: TRIAL_BANNER_HEIGHT}
}

export const TrialBanner: React.FC = () => {
  const {currentUser} = useAuth()
  const instance = currentUser?.instance
  const plan = instance?.plan
  const trialStartedAt = instance?.trial_started_at

  if (plan?.name.toLowerCase() != 'plano trial' || !trialStartedAt) return null

  const trialStartedAtDate = new Date(trialStartedAt)
  const now = new Date()
  const diffTime = now.getTime() - trialStartedAtDate.getTime()
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24))
  const daysLeft = 15 - diffDays

  if (daysLeft <= 0) return null

  return (
    <div
      className={clsx(
        'alert',
        'bg-warning',
        'border-0',
        'rounded-0',
        'd-flex',
        'align-items-center',
        'px-5',
        'mb-0',
        'justify-content-center',
        'shadow-sm',
        'text-dark',
        'fw-bold',
        'trial-banner'
      )}
      style={{
        zIndex: 1100,
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: TRIAL_BANNER_HEIGHT,
        display: 'flex',
        alignItems: 'center',
        color: '#212529',
      }}
    >
      <KTSVG path='/media/icons/duotune/general/gen002.svg' className='svg-icon-2x me-3' />
      Você está no período de teste gratuito. Aproveite todos os recursos ilimitados. {' '}
      {daysLeft === 1 ? (
        <>Falta <span className='mx-1'>1</span> dia para expirar.</>
      ) : (
        <>Faltam <span className='mx-1'>{daysLeft}</span> dias para expirar.</>
      )}
    </div>
  )
}
